module.exports = __webpack_public_path__ + "img/auditoria.7ebcbfc4.png";